import React from "react";
import { Modal } from "../../../../shared/components/ui/Modal";
import { CreateUserForm } from "../CreateUserForm/CreateUserForm";
import type { CreateUserFormValues } from "../CreateUserForm/CreateUserForm";

interface CreateUserModalProps {
  open: boolean;
  onClose: () => void;
  defaultValues: CreateUserFormValues;
  onSubmit: (data: CreateUserFormValues) => void;
  isSubmitting?: boolean;
}

export const CreateUserModal: React.FC<CreateUserModalProps> = ({
  open,
  onClose,
  defaultValues,
  onSubmit,
  isSubmitting,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Crear Usuario"
      // slightly wider modal for more natural form layout
      size="lg"
      className="p-6 sm:p-8"
    >
      <CreateUserForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        onCancel={onClose}
        isSubmitting={isSubmitting}
      />
    </Modal>
  );
};

// Re-export the form values type for convenience
export type { CreateUserFormValues };
